import { Icon } from "@chakra-ui/react";
const BackArrowIcon = () => {
  return (
    <>
      <Icon
        width="5"
        height="5"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.97 10C1.97 14.41 5.59 18.03 10 18.03C14.41 18.03 18.03 14.41 18.03 10C18.03 5.59 14.41 1.97 10 1.97C5.59 1.97 1.97 5.59 1.97 10ZM0 10C0 4.46 4.46 0 10 0C15.54 0 20 4.46 20 10C20 15.54 15.54 20 10 20C4.46 20 0 15.54 0 10ZM8.46 9V6L4.5 10L8.46 14V11H15.5V9"
          fill="white"
        />
      </Icon>
    </>
  );
};

export default BackArrowIcon;
